<template>
  <div class="PublicSwitches" ref="PublicSwitches">
    <b-form-checkbox v-model="temp_value" @change="UpdateCheck" switch size="lg">{{GetName}}</b-form-checkbox>
  </div>

</template>

<script>
export default {
  props:['value','Name','OffName'],
  data(){
      return {
        temp_value: this.value,
      }
  },
  watch:{
    value()
    {
      this.temp_value = this.value;
    }
  },
  computed:{
    GetName()
    {
      return this.temp_value?this.Name:this.OffName;
    }
  },
  mounted(){  
    
  },
  beforeDestroy() 
  {
 
  },
  methods:{
    UpdateCheck()
    {
      this.$emit("input", this.temp_value);
    }
  }
}
</script>
<style lang="scss" scoped>
.PublicSwitches
{
  margin-bottom: 10px !important
}
</style>